module.exports = __webpack_public_path__ + "img/404.0a498c16.svg";